import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: './acceptance-modal.component.html',
  styleUrls: ['./acceptance-modal.component.css'],
  standalone: false
})
export class AcceptanceModalComponent implements OnInit {
  @Input() isRecheck: boolean = false;
  env = environment;
  accountForm: UntypedFormGroup;

  constructor(
    private modalCtrl: ModalController,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.accountForm = this.fb.group({
      generalTerms: [false, Validators.requiredTrue]
    });
  }

  onClose(data?) {
    this.modalCtrl.dismiss(data);
  }

}
